import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
<link href = "fonts/roboto/stylesheet.css" rel = "stylesheet" type = "text/css" />
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

